import { TransportActions, TransportActionTypes } from "../actions/transport.action";

export interface TransportState {
  transportPriceList: any[];
  transportPriceListLoading: boolean;
  transportPriceListError: boolean;
  
  discountedTransportPriceList: any[];
  discountedTransportPriceListLoading: boolean;
  discountedTransportPriceListError: boolean;

  createDiscountedTransportPriceSuccess: boolean;
  createDiscountedTransportPriceLoading: boolean;
  createDiscountedTransportPriceError: boolean;
  createdDiscountedTransportPrice: any;

  updateDiscountedTransportPriceSuccess: boolean;
  updateDiscountedTransportPriceLoading: boolean;
  updateDiscountedTransportPriceError: boolean;
  updatedDiscountedTransportPrice: any;

  transportOptions: any[];
  transportOptionsLoading: boolean;
  transportOptionsError: boolean;

  transportLoads: any[];
  transportLoadsLoading: boolean;
  transportLoadsError: boolean;
  
  transportLoadsPurchase: any[];
  transportLoadsPurchaseLoading: boolean;
  transportLoadsPurchaseError: boolean;

  transportAreas: any[];
  transportAreasLoading: boolean;
  transportAreasError: boolean;

  transportDistricts: any[];
  transportDistrictsLoading: boolean;
  transportDistrictsError: boolean;
}

export const initialState: TransportState = {
  transportPriceList: [],
  transportPriceListLoading: false,
  transportPriceListError: false,

  discountedTransportPriceList: [],
  discountedTransportPriceListLoading: false,
  discountedTransportPriceListError: false,

  createDiscountedTransportPriceSuccess: false,
  createDiscountedTransportPriceLoading: false,
  createDiscountedTransportPriceError: false,
  createdDiscountedTransportPrice: null,

  updateDiscountedTransportPriceSuccess: false,
  updateDiscountedTransportPriceLoading: false,
  updateDiscountedTransportPriceError: false,
  updatedDiscountedTransportPrice: null,

  transportOptions: [],
  transportOptionsLoading: false,
  transportOptionsError: false,

  transportLoads: [],
  transportLoadsLoading: false,
  transportLoadsError: false,

  transportLoadsPurchase: [],
  transportLoadsPurchaseLoading: false,
  transportLoadsPurchaseError: false,

  transportAreas: [],
  transportAreasLoading: false,
  transportAreasError: false,

  transportDistricts: [],
  transportDistrictsLoading: false,
  transportDistrictsError: false,
};

export function reducer(
  state = initialState,
  action: TransportActions
): TransportState {
  switch (action.type) {
    case TransportActionTypes.GET_TRANSPORT_PRICE_LIST: {
      return {
        ...state,
        transportPriceListLoading: true,
        transportPriceListError: false,
      };
    }

    case TransportActionTypes.GET_TRANSPORT_PRICE_LIST_SUCCESS: {
      return {
        ...state,
        transportPriceList: action.payload,
        transportPriceListLoading: false,
        transportPriceListError: false,
      };
    }

    case TransportActionTypes.GET_TRANSPORT_PRICE_LIST_FAILURE: {
      return {
        ...state,
        transportPriceListLoading: false,
        transportPriceListError: true,
      };
    }

    case TransportActionTypes.GET_DISCOUNTED_TRANSPORT_PRICE: {
      return {
        ...state,
        discountedTransportPriceListLoading: true,
        discountedTransportPriceListError: false,
      };
    }

    case TransportActionTypes.GET_DISCOUNTED_TRANSPORT_PRICE_SUCCESS: {
      return {
        ...state,
        discountedTransportPriceList: action.payload,
        discountedTransportPriceListLoading: false,
        discountedTransportPriceListError: false,
      };
    }

    case TransportActionTypes.GET_DISCOUNTED_TRANSPORT_PRICE_FAILURE: {
      return {
        ...state,
        discountedTransportPriceListLoading: false,
        discountedTransportPriceListError: true,
      };
    }

    case TransportActionTypes.CREATE_DISCOUNTED_TRANSPORT_PRICE: {
      return {
        ...state,
        createDiscountedTransportPriceLoading: true,
        createDiscountedTransportPriceError: false,
      };
    }

    case TransportActionTypes.CREATE_DISCOUNTED_TRANSPORT_PRICE_SUCCESS: {
      return {
        ...state,
        createdDiscountedTransportPrice: action.payload,
        createDiscountedTransportPriceSuccess: true,
        createDiscountedTransportPriceLoading: false,
        createDiscountedTransportPriceError: false,
      };
    }

    case TransportActionTypes.CREATE_DISCOUNTED_TRANSPORT_PRICE_FAILURE: {
      return {
        ...state,
        createDiscountedTransportPriceLoading: false,
        createDiscountedTransportPriceError: true,
      };
    }

    case TransportActionTypes.UPDATE_DISCOUNTED_TRANSPORT_PRICE: {
      return {
        ...state,
        updateDiscountedTransportPriceLoading: true,
        updateDiscountedTransportPriceError: false,
      };
    }

    case TransportActionTypes.UPDATE_DISCOUNTED_TRANSPORT_PRICE_SUCCESS: {
      return {
        ...state,
        updateDiscountedTransportPriceSuccess: true,
        updateDiscountedTransportPriceLoading: false,
        updateDiscountedTransportPriceError: false,
      };
    }

    case TransportActionTypes.UPDATE_DISCOUNTED_TRANSPORT_PRICE_FAILURE: {
      return {
        ...state,
        updateDiscountedTransportPriceLoading: false,
        updateDiscountedTransportPriceError: true,
      };
    }

    case TransportActionTypes.GET_TRANSPORT_PRICE: {
      return {
        ...state,
        transportPriceListLoading: true,
        transportPriceListError: false,
      };
    }

    case TransportActionTypes.GET_TRANSPORT_PRICE_SUCCESS: {
      return {
        ...state,
        transportPriceList: action.payload,
        transportPriceListLoading: false,
        transportPriceListError: false,
      };
    }

    case TransportActionTypes.GET_TRANSPORT_PRICE_FAILURE: {
      return {
        ...state,
        transportPriceListLoading: false,
        transportPriceListError: true,
      };
    }

    case TransportActionTypes.CLEAR_TRANSPORT_PRICE_LIST: {
      return {
        ...state,
        transportPriceList: []
      };
    }

    case TransportActionTypes.GET_TRANSPORT_OPTIONS: {
      return {
        ...state,
        transportOptionsLoading: true,
        transportOptionsError: false,
      };
    }

    case TransportActionTypes.GET_TRANSPORT_OPTIONS_SUCCESS: {
      return {
        ...state,
        transportOptions: action.payload,
        transportOptionsLoading: false,
        transportOptionsError: false,
      };
    }

    case TransportActionTypes.GET_TRANSPORT_OPTIONS_FAILURE: {
      return {
        ...state,
        transportOptionsLoading: false,
        transportOptionsError: true,
      };
    }

    case TransportActionTypes.GET_TRANSPORT_LOADS: {
      return {
        ...state,
        transportLoadsLoading: true,
        transportLoadsError: false,
      };
    }

    case TransportActionTypes.GET_TRANSPORT_LOADS_SUCCESS: {
      return {
        ...state,
        transportLoads: action.payload,
        transportLoadsLoading: false,
        transportLoadsError: false,
      };
    }

    case TransportActionTypes.GET_TRANSPORT_LOADS_FAILURE: {
      return {
        ...state,
        transportLoadsLoading: false,
        transportLoadsError: true,
      };
    }
    
    // case TransportActionTypes.GET_TRANSPORT_LOADS_PURCHASE: {
    //   return {
    //     ...state,
    //     transportLoadsPurchaseLoading: true,
    //     transportLoadsPurchaseError: false,
    //   };
    // }

    // case TransportActionTypes.GET_TRANSPORT_LOADS_PURCHASE_SUCCESS: {
    //   return {
    //     ...state,
    //     transportLoadsPurchase: action.payload,
    //     transportLoadsPurchaseLoading: false,
    //     transportLoadsPurchaseError: false,
    //   };
    // }

    // case TransportActionTypes.GET_TRANSPORT_LOADS_PURCHASE_FAILURE: {
    //   return {
    //     ...state,
    //     transportLoadsPurchaseLoading: false,
    //     transportLoadsPurchaseError: true,
    //   };
    // }

    case TransportActionTypes.GET_TRANSPORT_AREAS: {
      return {
        ...state,
        transportAreasLoading: true,
        transportAreasError: false,
      };
    }

    case TransportActionTypes.GET_TRANSPORT_AREAS_SUCCESS: {
      return {
        ...state,
        transportAreas: action.payload,
        transportAreasLoading: false,
        transportAreasError: false,
      };
    }

    case TransportActionTypes.GET_TRANSPORT_AREAS_FAILURE: {
      return {
        ...state,
        transportAreasLoading: false,
        transportAreasError: true,
      };
    }

    case TransportActionTypes.GET_TRANSPORT_DISTRICTS: {
      return {
        ...state,
        transportDistrictsLoading: true,
        transportDistrictsError: false,
      };
    }

    case TransportActionTypes.GET_TRANSPORT_DISTRICTS_SUCCESS: {
      return {
        ...state,
        transportDistricts: action.payload,
        transportDistrictsLoading: false,
        transportDistrictsError: false,
      };
    }

    case TransportActionTypes.GET_TRANSPORT_DISTRICTS_FAILURE: {
      return {
        ...state,
        transportDistrictsLoading: false,
        transportDistrictsError: true,
      };
    }

    case TransportActionTypes.CLEAR_TRANSPORT_AREAS: {
      return {
        ...state,
        transportAreas: []
      };
    }

    case TransportActionTypes.CLEAR_TRANSPORT_DISTRICTS: {
      return {
        ...state,
        transportDistricts: []
      };
    }

    default:
      return state;
  }
}
